import Vue from 'vue';
import ProductVar from '@/classes/productVar';

const state = {
  productVars: {},
};

const getters = {
  get: state => state.productVars,
};

const mutations = {
  set(state, productVars = []) {
    productVars.forEach(pv => {
      const productVar = new ProductVar(pv);
      Vue.set(state.productVars, productVar.type, productVar);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
